export function topSlider() {
    const slider = $(".top-slider");
    this.$window.on("load", () => {
        setTimeout(() => {
        slider.on("init", function(event, slick) {
            slider.find(".slick-current").addClass("animate");
            $('.top-slider .slide').addClass('start');
        });
        slider.find(".slides").slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            fade: true,
            speed: 1500,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendArrows: ".top-slider-controls",
            prevArrow: "<button class=\"slick-arrow slick-prev\">Previous slide</button>",
            nextArrow: "<button class=\"slick-arrow slick-next\">Next slide</button>",
        });
    }, 2000);
});
}


// WEBPACK FOOTER //
// ./assets/js/modules/topSlider.js